import React from "react";

import BAMIcon from "./icons/partners/BAM";
import ChompIcon from "./icons/partners/Chomp";
import HealeIcon from "./icons/partners/Heale";
import NoshIcon from "./icons/partners/Nosh";
import PizzaDAOIcon from "./icons/partners/PizzaDAO";
import RadishIcon from "./icons/partners/Radish";
import ZuulIcon from "./icons/partners/Zuul";

const LogoSection: React.FC = () => {
  return (
    <section className="bg-local-green py-12">
      <div className="max-w-screen-xl w-full px-8 mx-auto">
        <h2 className="text-3xl font-semibold text-white text-center mb-8">
          Our Partners
        </h2>
        <div className="grid grid-cols-2 gap-8 text-gray-500 sm:gap-12 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7">
          <a
            href="https://www.noshdelivery.co/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <NoshIcon />
          </a>

          <a
            href="https://www.blackandmobile.com/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <BAMIcon />
          </a>

          <a
            href="https://www.chomp.com/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <ChompIcon />
          </a>
          <a
            href="https://www.globalpizzaparty.xyz/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <PizzaDAOIcon />
          </a>
          <a
            href="https://radish.coop/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <RadishIcon />
          </a>
          <a
            href="https://healelabs.com/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <HealeIcon />
          </a>
          <a
            href="https://www.zuul.com/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <ZuulIcon />
          </a>
        </div>
      </div>
    </section>
  );
};

export default LogoSection;
